export default __webpack_public_path__ + "static/media/pic4.cf228c8d.jpg";